__turbopack_context__.v({
  "bannerWrapper": "announcementbannergroup-module-scss-module__GpKBtW__bannerWrapper",
  "colorSet-base": "announcementbannergroup-module-scss-module__GpKBtW__colorSet-base",
  "colorSet-inverse": "announcementbannergroup-module-scss-module__GpKBtW__colorSet-inverse",
  "colorSet-sxmBlue": "announcementbannergroup-module-scss-module__GpKBtW__colorSet-sxmBlue",
  "wrapper": "announcementbannergroup-module-scss-module__GpKBtW__wrapper",
});
